import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpUtils} from '../../shared/http-utils';
import {URL_BASE} from '../../core/constants';
import {map} from 'rxjs/operators';
import {FuelType, FuelTypeRegion} from './fuel-type.model';

@Injectable()
export class FuelTypeService {

  private FUEL_TYPE_URI = `${URL_BASE}/api/decarbonization/fuel-types`;

  constructor(
    private http: HttpClient
  ) {
  }

  public getFuelTypes(): Observable<Array<FuelType>> {
    const headers = HttpUtils.createHeaders();
    const url = `${this.FUEL_TYPE_URI}`;

    return this.http.get(url, {headers}).pipe(
      map((result: any[]) => result.map(data => FuelType.fromDto(data)))
    );
  }

  public getRemovableFuelTypeIds(): Observable<Array<string>> {
    const headers = HttpUtils.createHeaders();
    const url = `${this.FUEL_TYPE_URI}/removable`;

    return this.http.get(url, {headers}).pipe(
      map((result: any[]) => result.map(data => data.toString()))
    );
  }

  public getSelfFuelTypes(): Observable<Array<FuelTypeRegion>> {
    const headers = HttpUtils.createHeaders();
    const url = `${this.FUEL_TYPE_URI}/self`;

    return this.http.get(url, {headers}).pipe(
      map((result: any[]) => result.map(data => FuelTypeRegion.fromDto(data)))
    );
  }

  public getSelfRemovableFuelTypeRegionIds(): Observable<Array<string>> {
    const headers = HttpUtils.createHeaders();
    const url = `${this.FUEL_TYPE_URI}/self/removable`;

    return this.http.get(url, {headers}).pipe(
      map((result: any[]) => result.map(data => data.toString()))
    );
  }

  public createFuelType(fuelTypeCreationRequest: string) {
    const headers = HttpUtils.createHeaders();
    const url = `${this.FUEL_TYPE_URI}`;

    return this.http.post(url, {label: fuelTypeCreationRequest}, {headers}).pipe(
      map(result => FuelType.fromDto(result))
    );
  }

  public addOwnRegionFuelType(fuelType: FuelType) {
    const headers = HttpUtils.createHeaders();
    const url = `${this.FUEL_TYPE_URI}/self/${fuelType.id}`;

    return this.http.put(url, {}, {headers}).pipe(
      map(result => FuelTypeRegion.fromDto(result))
    );
  }

  public deleteFuelType(fuelType: FuelType) {
    const headers = HttpUtils.createHeaders();
    const url = `${this.FUEL_TYPE_URI}/${fuelType.id}`;

    return this.http.delete(url, {headers});
  }

  public deleteOwnRegionFuelType(fuelTypeRegion: FuelTypeRegion) {
    const headers = HttpUtils.createHeaders();
    const url = `${this.FUEL_TYPE_URI}/self/${fuelTypeRegion.id}`;

    return this.http.delete(url, {headers});
  }
}
